import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { MotivoIndisponibilidadeService } from '../services/motivo-indisponibilidade.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-motivos-indisponibilidade-edit',
	templateUrl: './motivos-indisponibilidade-edit.component.html',
	styleUrls: ['./motivos-indisponibilidade-edit.component.css'],
	animations: [loadingFade]
})
export class MotivosIndisponibilidadeEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public motivo_indisponibilidade_id = null;

	public formMotivoIndisp: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private motivoIndispSvc: MotivoIndisponibilidadeService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.motivo_indisponibilidade_id = params.id;
				// pega dados a partir do id
				this.motivoIndispSvc.getMotivoIndisponibilidade(params.id).then((data: any) => {
					this.preencheForm({
						motivo_indisponibilidade_id: data.motivo_indisponibilidade_id,
						motivo_indisponibilidade_nome: data.motivo_indisponibilidade_nome
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formMotivoIndisp = this.fb.group({
			motivo_indisponibilidade_id: null,
			motivo_indisponibilidade_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formMotivoIndisp.setValue(dados);
	}

	enviaMotivoIndisp() {
		if (this.formMotivoIndisp.valid) {
			this.submitting = true;

			let toSend = this.formMotivoIndisp.value;

			if (this.motivo_indisponibilidade_id === null) { // criar
				this.motivoIndispSvc.criaMotivoIndisponibilidade(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Motivo criado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/motivosindisponibilidade']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.motivoIndispSvc.editaMotivoIndisponibilidade(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Motivo alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/motivosindisponibilidade']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formMotivoIndisp.controls){
				let campo = this.formMotivoIndisp.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formMotivoIndisp.get(nome);
		return input.touched && input.invalid;
	}
}
